import React from "react";
import { Box, Flex, Text, Progress, Icon, Stack } from "@chakra-ui/react";
import { ProgressStatProps } from "../../types/ui";
import CustomCard from "../ui/card";

export default function ProgressStat({ amount, ...props }: ProgressStatProps) {    
    return (
        <CustomCard key={props.id} width={props.width} flexGrow={1} children={(
            <>
                <Flex alignItems={'center'} justifyContent='space-between'>
                    <Text fontSize='lg' color={'blackAlpha.900'} fontWeight='semibold'>{props.currency}{amount}{props.percentage}</Text>
                    {props.icon && <Icon w={4} h={4} as={props.icon} fill={props.barColour} />}
                </Flex>
                <Box>
                    <Text color={'gray.500'} fontSize='sm'>{props.subTitle}</Text>
                </Box>
                <Stack marginTop={'8'}>
                    <Progress value={props.currentRate!} size='xs' max={100} colorScheme={props.barColour} />
                    <Text color={'gray.500'} fontSize='sm'>{props.currentRate}%</Text>
                </Stack>
            </>
        )} />
    )
}